// extracted by mini-css-extract-plugin
module.exports = {"inputTitle":"Login_inputTitle__1pWUR","loginInput":"Login_loginInput__23j4Q","button":"Login_button__2Dvb9","forgotPassword":"Login_forgotPassword__19ojO"};